export default {"src":"/_next/static/media/dgb.c2bbf861.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};